export default __webpack_public_path__ + "static/media/0x127984b5e6d5c59f81dacc9f1c8b3bdc8494572e.487d8800.webp";